import shop1 from "../../images/shop-hero-image-2.webp";
import shop2 from "../../images/shop-hero-image-1.webp";
import shop3 from "../../images/shop-hero-image-3.webp";

const ShopFirstSection = () => {
  return (
    <section className="flex flex-col lg:flex-row justify-center gap-[30px] py-[50px] lg:py-[70px] px-[20px]">
      <div
        className="h-[40vh] lg:h-[65vh] w-[100%] lg:w-[30%] rounded-lg overflow-hidden relative"
        id="heroshop"
      >
        <img
          src={shop1}
          alt=""
          id="shopbox"
          className="h-[100%] lg:h-[100%] w-[100%] rounded-lg transition-all ease-in-out duration-700"
        />
        <div className="absolute top-0 left-0 bottom-0 right-0 py-[30px] px-[20px] flex flex-col justify-between bg-[#0000001e]">
          <div className="flex justify-between">
            <div className="bg-white py-[5px] px-[10px] rounded-[5px]">
              Collections
            </div>
            <button className="bg-white hover:bg-black hover:text-amber-500 h-[40px] w-[40px] rounded-[50%] transition-all ease-in-out duration-150">
              <i class="fa-solid fa-arrow-up-right-from-square"></i>
            </button>
          </div>
          <p className="text-white font-[600] text-[19px] w-[80%]">
            Blandit Natoque Elementum Nascetur
          </p>
        </div>
      </div>
      <div
        className="h-[50vh] lg:h-[65vh] w-[100%] lg:w-[20%] rounded-lg overflow-hidden relative"
        id="heroshop"
      >
        <img
          src={shop2}
          alt=""
          id="shopbox"
          className="h-[100%] w-[100%] rounded-lg transition-all ease-in-out duration-700"
        />
        <div className="absolute top-0 left-0 bottom-0 right-0 py-[30px] px-[20px] flex flex-col justify-between bg-[#0000001e]">
          <div className="flex justify-between">
            <div className="bg-white py-[5px] px-[10px] rounded-[5px]">
              Collections
            </div>
            <button className="bg-white hover:bg-black hover:text-amber-500 h-[40px] w-[40px] rounded-[50%] transition-all ease-in-out duration-150">
              <i class="fa-solid fa-arrow-up-right-from-square"></i>
            </button>
          </div>
          <p className="text-white font-[600] text-[19px]">
            Blandit Natoque Elementum Nascetur
          </p>
        </div>
      </div>
      <div
        className="h-[50vh] lg:h-[65vh] w-[40%] rounded-lg overflow-hidden relative hidden lg:block"
        id="heroshop"
      >
        <img
          src={shop3}
          alt=""
          id="shopbox"
          className="h-[100%] w-[100%] rounded-lg transition-all ease-in-out duration-700"
        />
        <div className="absolute top-0 left-0 bottom-0 right-0 py-[30px] px-[20px] flex flex-col justify-between bg-[#0000001e]">
          <div className="flex justify-between">
            <div className="bg-white py-[5px] px-[10px] rounded-[5px]">
              Collections
            </div>
            <button className="bg-white hover:bg-black hover:text-amber-500 h-[40px] w-[40px] rounded-[50%] transition-all ease-in-out duration-150">
              <i class="fa-solid fa-arrow-up-right-from-square"></i>
            </button>
          </div>
          <div className="relative">
            <input
              type="email"
              name="email"
              id="input-email"
              className="py-[15px] px-[10px] rounded-[5px] bg-white w-[100%] placeholder:text-gray-400"
            />
            <button className="absolute top-[10%] left-[80%] bg-black py-[10px] px-[10px] rounded-[5px] text-white font-[600] hover:bg-amber-500 hover:text-black">
              Subscribe
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShopFirstSection;
